import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllProductCategories, getAllProducts } from "../../../../api/action/products.jsx";
import Carousel from "./components/Carousel.jsx";
import CategorySection from "./components/CategorySection.jsx";
import ScrollableFeaturedProducts from "./components/ScrollableFeaturedProducts.jsx";
import { academyLogger } from "utils/logger";

function SecondRetailTemplate() {
  const [categoryProducts, setCategoryProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companyPrimaryId = useSelector((state) => state.companyReducer.company?.primaryId);
  const user = useSelector((state) => state?.auth?.data);

  useEffect(() => {
    if (!companyPrimaryId) return;
    const fetchProducts = async () => {
      try {
        const response = await getAllProducts(companyPrimaryId)(dispatch);
        setCategoryProducts(Array.isArray(response) ? response : []);
      } catch (error) {
        academyLogger.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, [companyPrimaryId, dispatch]);

  useEffect(() => {
    if (!companyPrimaryId) return;
    const fetchCategories = async () => {
      try {
        const response = await getAllProductCategories(companyPrimaryId)(dispatch);
        setCategories(Array.isArray(response) ? response : []);
      } catch (error) {
        academyLogger.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, [companyPrimaryId, dispatch]);

  return (
    <>
      <Carousel />
      <CategorySection categories={categories} />
      <ScrollableFeaturedProducts productList={categoryProducts} navigate={navigate} loggedIn={!!user} />
    </>
  );
}

export default SecondRetailTemplate;
